var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _c("img", {
      staticClass: "image",
      attrs: { src: require("@/assets/images/paysuccess.png") }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "info-group" }, [_vm._v("支付成功")]),
    _vm._v(" "),
    _c("div", { staticClass: "btn", on: { click: _vm.JumpToHome } }, [
      _vm._v("返回")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b9361e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../app/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b9361e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../app/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/payticket.vue
// module id = null
// module chunks = 